import createIconComponent from '../bc9b7e13473c3bebabd83c78ec2a0778f96c4118bed2ed7cc3a817be7d068301.cfe-internal.js';

/* THIS FILE IS AUTO-GENERATED */
var CaretRightIcon = /*#__PURE__*/createIconComponent('CaretRight', '<path d="M10.5 16.6422L10.5 7.35798C10.5 7.14945 10.7602 7.05361 10.896 7.21209L14.875 11.8542C14.947 11.9382 14.947 12.062 14.875 12.146L10.896 16.7881C10.7602 16.9466 10.5 16.8507 10.5 16.6422Z"/>');

export { CaretRightIcon as default };
